import { apiClient } from './apiClient';

export interface YieldGridCell {
  yield: number;
  color: string;
}

export interface YieldGridData {
  grid_data: Record<string, Record<string, YieldGridCell>>;
  blocks: string[];
  inverters: string[];
  percentile_bands: PercentileBand[];
  summary: {
    total_records: number;
    avg_yield: number;
    min_yield: number;
    max_yield: number;
    percentile_value: number;
  };
}

export interface PercentileBand {
  percentile: number;
  value: number;
  color: string;
  is_target: boolean;
}

export interface YieldPercentileData {
  percentile_bands: {
    percentile: number;
    lower_bound: number;
    upper_bound: number;
    color_code: string;
    label: string;
  }[];
}

export const yieldService = {
  getYieldGridData: async (
    date?: string, 
    percentile?: number, 
    plantId?: string
  ): Promise<YieldGridData> => {
    const params = new URLSearchParams();
    if (date) params.append('date', date);
    if (percentile) params.append('percentile', percentile.toString());
    if (plantId) params.append('plant_id', plantId);
    
    const response = await apiClient.get(`/api/monitoring/yield-grid/?${params}`);
    return response.data;
  },

  getYieldPercentiles: async (plantId?: string): Promise<YieldPercentileData> => {
    const params = new URLSearchParams();
    if (plantId) params.append('plant_id', plantId);
    
    const response = await apiClient.get(`/api/monitoring/yield-percentiles/?${params}`);
    return response.data;
  }
};